// extracted by mini-css-extract-plugin
export default {"participants":"participants__56wqU","list":"list__3K0kM","buttons":"buttons__1n2rH","active":"active__B3CW5"};